import { render, staticRenderFns } from "./Safechart.vue?vue&type=template&id=9a6a3006&scoped=true"
import script from "./Safechart.vue?vue&type=script&lang=js"
export * from "./Safechart.vue?vue&type=script&lang=js"
import style0 from "./Safechart.vue?vue&type=style&index=0&id=9a6a3006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6a3006",
  null
  
)

export default component.exports